var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bxs-trash.svg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.80588 7.38937H4.88231V19.3959C4.88231 19.8858 5.07692 20.3556 5.42333 20.702C5.76973 21.0484 6.23957 21.243 6.72946 21.243H15.9652C16.4551 21.243 16.9249 21.0484 17.2714 20.702C17.6178 20.3556 17.8124 19.8858 17.8124 19.3959V7.38937H5.80588ZM9.50019 18.4723H7.65304V10.1601H9.50019V18.4723ZM15.0416 18.4723H13.1945V10.1601H15.0416V18.4723ZM15.6124 4.61864L14.1181 2.77148H8.57661L7.08227 4.61864H3.03516V6.46579H19.6595V4.61864H15.6124Z",
    fill: "#F90505"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.d5979f18fe65ff25b74de94ef436debf.svg";
export { ForwardRef as ReactComponent };